import Rollbar from 'rollbar';
import {ignoredMessages} from './ignore';
import config from 'config';

const stagingOrProduction = ['production', 'staging'].includes(__ENV__);

// This is the single, authoritative Rollbar configuration.
// It is enabled for uncaught errors and will be used everywhere.
export const rollbarConfig = {
  accessToken: config.services.rollbar.accessToken,
  captureUncaught: stagingOrProduction,
  captureUnhandledRejections: stagingOrProduction,
  enabled: true,
  hostSafeList: ['customink.com'],
  ignoredMessages,
  payload: {
    environment: config.services.rollbar.environment,
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  }
};

// This is the single, authoritative Rollbar instance.
// It is initialized here and imported by both React and non-React code.
const rollbar = new Rollbar(rollbarConfig);

export default rollbar;
